export const REPORT_ACCESS_CONSTANTS = {
  MAX_ACCESS_USER_COUNT: 30,
  USER_ROLES: ['pay_equity_admin', 'pay_equity_user'],
  VIEW_PERMISSION_CODE: 'VIEW',
  EDIT_PERMISSION_CODE: 'EDIT',
  DELETE_PERMISSION_CODE: 'DELETE',
  IAM_USER_NOT_FOUND_ERROR_CODE: '40103',
};